import { Component } from '@angular/core';
import { TITLE_SEARCH_MATTER_STATE } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Observable } from 'rxjs';
import { SavedPin } from '@models/teranet';
import { Select } from '@ngxs/store';
import { SalePinState } from '@state/sale_pins';
import { TestHooks } from './instruments.hooks';

@Component({
	selector: 'app-instruments',
	templateUrl: './instruments.component.html',
	styleUrls: ['./instruments.component.scss'],
	standalone: false,
})
export class TeranetStepperInstrumentsComponent {
	testHooks = TestHooks;
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@Select(SalePinState.getSelected) selectedPin$: Observable<SavedPin>;

	constructor(private matterDispatch: MatterDispatch) {}

	next = (): void => {
		this.matterDispatch.SetTitleState(
			this.matterId,
			TITLE_SEARCH_MATTER_STATE.ADJACENT_ANALYSIS,
		);
	};

	back = (): void => {
		this.matterDispatch.SetTitleState(
			this.matterId,
			TITLE_SEARCH_MATTER_STATE.SYNC,
		);
	};
}
